const HomeData = {
    tag_line_1: "Hi, I'm a Front End",
    tag_line_2: "Developer",
    location: "based in West Bengal, IN.",
    btn_1: "View My Projects",
    btn_2: "Contact Me",
    img_src: "assets/avatar.png",
    img_alt: "Profile Img",
};

export default HomeData;
